import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Box } from '../Box/Box.js';

const BreakBox = styled(Box) `
  word-break: break-all;
`;
const CardContent = ({ children, ...props }) => {
    return jsx(BreakBox, { ...props, children: children });
};

export { CardContent };
